import React, { useState } from 'react';
import { Button } from '../../../ui/button';

const ProcessingTab = ({ caseId, caseData, onRefresh, token }) => {
  const [assignedTo, setAssignedTo] = useState(caseData?.assigned_to || '');
  const [internalNotes, setInternalNotes] = useState(caseData?.internal_notes || '');
  const [appointment, setAppointment] = useState(caseData?.appointment || { needed: false, date: '', time_window: '', address: '', contact_name: '', contact_phone: '' });
  const [flags, setFlags] = useState(caseData?.processing_flags || { images_ok: false, docs_ok: false, liability_unclear: false, fraud_risk: false, urgent: false });

  const saveAssignment = async () => {
    try {
      await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/admin/cases/${caseId}/assign`, {
        method: 'PATCH',
        headers: { 'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json' },
        body: JSON.stringify({ assigned_to: assignedTo })
      });
      onRefresh();
      alert('Gespeichert');
    } catch { alert('Fehler'); }
  };

  const saveAppointment = async () => {
    try {
      await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/admin/cases/${caseId}/appointment`, {
        method: 'PATCH',
        headers: { 'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json' },
        body: JSON.stringify(appointment)
      });
      onRefresh();
      alert('Gespeichert');
    } catch { alert('Fehler'); }
  };

  const saveFlags = async () => {
    try {
      await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/admin/cases/${caseId}/flags`, {
        method: 'PATCH',
        headers: { 'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json' },
        body: JSON.stringify(flags)
      });
      onRefresh();
      alert('Gespeichert');
    } catch { alert('Fehler'); }
  };

  const saveNotes = async () => {
    try {
      await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/admin/cases/${caseId}/internal-notes`, {
        method: 'PATCH',
        headers: { 'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json' },
        body: JSON.stringify({ notes: internalNotes })
      });
      alert('Gespeichert');
    } catch { alert('Fehler'); }
  };

  return (
    <div className="space-y-8">
      <div className="bg-gray-50 border border-gray-200 rounded-xl p-6">
        <h3 className="font-bold text-gray-900 mb-4">Sachverständigen-Zuweisung</h3>
        <div className="flex gap-3">
          <input
            type="text"
            value={assignedTo}
            onChange={e => setAssignedTo(e.target.value)}
            placeholder="Name oder ID"
            className="flex-1 px-4 py-3 border rounded-xl"
          />
          <Button onClick={saveAssignment} className="bg-brand-green text-white">Speichern</Button>
        </div>
      </div>

      <div className="bg-gray-50 border border-gray-200 rounded-xl p-6">
        <h3 className="font-bold text-gray-900 mb-4">Termin</h3>
        <label className="flex items-center gap-2 mb-4">
          <input type="checkbox" checked={appointment.needed} onChange={e => setAppointment({...appointment, needed: e.target.checked})} />
          <span className="text-sm font-semibold">Termin benötigt</span>
        </label>
        {appointment.needed && (
          <div className="grid md:grid-cols-2 gap-4 mb-4">
            <input type="date" value={appointment.date} onChange={e => setAppointment({...appointment, date: e.target.value})} className="px-4 py-2 border rounded-xl" />
            <input type="text" value={appointment.time_window} onChange={e => setAppointment({...appointment, time_window: e.target.value})} placeholder="Zeitfenster" className="px-4 py-2 border rounded-xl" />
            <input type="text" value={appointment.address} onChange={e => setAppointment({...appointment, address: e.target.value})} placeholder="Adresse" className="px-4 py-2 border rounded-xl" />
            <input type="text" value={appointment.contact_name} onChange={e => setAppointment({...appointment, contact_name: e.target.value})} placeholder="Kontakt" className="px-4 py-2 border rounded-xl" />
            <input type="text" value={appointment.contact_phone} onChange={e => setAppointment({...appointment, contact_phone: e.target.value})} placeholder="Telefon" className="px-4 py-2 border rounded-xl" />
          </div>
        )}
        <Button onClick={saveAppointment} className="bg-brand-green text-white">Speichern</Button>
      </div>

      <div className="bg-gray-50 border border-gray-200 rounded-xl p-6">
        <h3 className="font-bold text-gray-900 mb-4">Bearbeitungsflags</h3>
        <div className="grid md:grid-cols-2 gap-3 mb-4">
          {Object.keys(flags).map(key => (
            <label key={key} className="flex items-center gap-2">
              <input type="checkbox" checked={flags[key]} onChange={e => setFlags({...flags, [key]: e.target.checked})} />
              <span className="text-sm">{key.replace(/_/g, ' ')}</span>
            </label>
          ))}
        </div>
        <Button onClick={saveFlags} className="bg-brand-green text-white">Speichern</Button>
      </div>

      <div className="bg-gray-50 border border-gray-200 rounded-xl p-6">
        <h3 className="font-bold text-gray-900 mb-4">Interne Notizen</h3>
        <textarea value={internalNotes} onChange={e => setInternalNotes(e.target.value)} rows={6} className="w-full px-4 py-3 border rounded-xl mb-3" placeholder="Interne Notizen..." />
        <Button onClick={saveNotes} className="bg-brand-green text-white">Speichern</Button>
      </div>
    </div>
  );
};

export default ProcessingTab;
